import { render, staticRenderFns } from "./OrderInfos.vue?vue&type=template&id=601aaba5"
import script from "./OrderInfos.vue?vue&type=script&lang=js"
export * from "./OrderInfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports